import { SidebarState } from "@/core/entities/sidebar/SidebarState";
import { ISidebarStateRepository } from "@/core/repositories/sidebarState";

export class SaveSidebarStateUseCase {
  constructor(private readonly sidebarStateRepository: ISidebarStateRepository) {}

  async execute(state: SidebarState): Promise<void> {
    await this.sidebarStateRepository.saveSidebarState(state);
  }
}
